import * as Styled from "./CampaignDetailsTable.styled"

export function CampaignDetailsTableSkeleton(props) {

    return <Styled.SkeletonContainer  {...props}>
        <Styled.Skeleton />
    </Styled.SkeletonContainer>
}


